const locationService = {
  redirect: url => {
    window.location = url;
  }
};
export default locationService;
